<template>
  <div></div>
</template>

<script>
import formElementMixin from "./formElementMixin";

export default {
  mixins: [formElementMixin],
  created() {
    this.value = this.optionConfig.defaultValue;
  },
  props: {
    optionConfig: {
      required: true,
      type: Object,
      validator: function (optionConfig) {
        return (
          optionConfig && Object.keys(optionConfig).includes("defaultValue")
        );
      },
    },
  },
};
</script>
